/**
 * @file: 右键菜单点击事件分发
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../cubeTree/index';
import CopySystem from '../copySystem/index';
import Remove from '../remove/index';
import History from '../history/index';
import LayerGroup from '../layerGroup';
import Select from '../select/index';
import LayerCubeSort from '../layerCubeSort';
import Textarea from '../textarea';
import Modal from '../modal';
import { StageEvent } from '../../message/index';
import { hide } from './toggleMenu';

function dispatchClickAction(): void {
    let $menu: JQuery<HTMLElement> = $('.shelvesbuild-w-contextmenus');

    $menu.bind('mousedown', function(): boolean {
        return false;
    });
    $menu.bind('mouseup', function(): boolean {
        return false;
    });
    $menu.bind('click', function(ev): boolean {
        let $actionItem: JQuery<HTMLElement> = $(ev.target).closest('.item');

        if (!$actionItem.length) {
            return false;
        }

        if ($actionItem.hasClass('has-children')) {
            return false;
        }

        let actionType: string = $actionItem.attr('data-type');

        dispatchAction(actionType);
        hide();
        return false;
    });
}

function dispatchAction(actionType: string): void {
    switch (actionType) {
        case 'copy':
            CopySystem.copy();
            break;

        case 'paste':
            CopySystem.paste();
            break;

        case 'cut':
            CopySystem.cut();
            break;

        case 'del':
            remove();
            break;

        case 'sortBySalesUp':
        case 'sortBySalesDown':
        case 'sortByBrandUp':
        case 'sortByBrandDown':
        case 'sortByTypeUp':
        case 'sortByTypeDown':
            LayerCubeSort.sortAllSelected(actionType);
            break;

        case 'addSpace':
            Textarea.create({
                width: 5,
                content: ''
            });
            break;

        case 'editTextarea':
            editTextareas();
            break;

        case 'breakLeft':
            LayerGroup.groupDisperse('left');
            break;

        case 'breakRight':
            LayerGroup.groupDisperse('right');
            break;

        default:
            break;
    }
}

function editTextareas(): void {
    let textareas: CubeId[] = Select.getSelectedByType('textarea');
    let nodes: CubeNode[] = CubeTree.findByCubeIds(textareas);

    StageEvent.fire('showModal', {
        eventFrom: 'stage',
        cubes: nodes
    });
}

function remove(): void {
    let delCubes: Array<CubeId> = Remove.findDelTargetsAllSelect();

    History.stackIn({
        type: 'remove',
        data: delCubes
    });
    Remove.del(delCubes);
    Select.panelSelectAsync();
}

export {
    dispatchClickAction
};
